import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from './locales/en.json'; // English translation file
//import frTranslation from './locales/fr.json'; // French translation file

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
//      fr: {
//        translation: frTranslation
//      },
      // Add more languages here
    },
    lng: "en", // Default language
    fallbackLng: "en", // Use English if the user's language can't be found
    interpolation: {
      escapeValue: false // React already does escaping
    }
  });

export default i18n;